// extracted by mini-css-extract-plugin
module.exports = {"articleButton":"articleButton-module--articleButton--24TDW","label":"articleButton-module--label--3JMFo"};